import React, { useState, useEffect, useRef } from "react";
import { View, Image, Text, TouchableOpacity, TextInput, ScrollView,  Pressable, ActivityIndicator, Platform} from "react-native";
import {  getUserDetails, } from "../../api/apiManager";
import { getDigiLockerStatus, panValidationV2, initiateVerification, digilockerConfig,} from "../../api/digiLockerApi";
import { closureTag, closureTagRefundCheck,getAllVehiclesListForClosureTag} from "../../api/serviceRequest";
import ModalAlert from "../../common/ModalAlert";
import Loader from "../../common/Loader";
import CText from "../../common/CText";
import CView from "../../common/CView";
import CButton from "../../common/CButton";
import CHeader from "../../common/CHeader";
import CImage from "../../common/CImage";
import QuickLinks from "../Profile/QuickLinks";
import * as RootNavigation from "../../utilities/RootNavigation";
import { useLocation } from "react-router-dom";
import useStyles from "./TagClosure_Styles";
import AdharModal from "./AdharModal_TagClosure";
import RenderDetails from "./RenderDetails";
import ButtonWidget from "./ButtonWidget_tagClosure";
import WarningWidget from "./WarningWidget_tagClosure";
import DetailsWidget from "./DetailsWidget_tagClosure";
import {isEmpty } from "lodash";
const bankAcntPattern = /^[0-9][0-9]*\.{0,1}[0-9]{0,2}$/;
// const ifscPattern = /^[A-Z]{4}[0][0-9]{6}$/;
const ifscPattern = RegExp(global?.ifscRegex)
export default function TagClosure(props) {
  const { state} = useLocation()
  if(state == null || state == undefined){ return RootNavigation.navigate("servicerequest/selectvehiclefortagclosure")}
  const selectedVehicle = state?.selectedVehicle

  let interval = useRef();
  let count = 0
  const styles = useStyles();
  const [vehicleLength, setVehicleLength] = useState(0)
  const [loading, setLoading] = useState(false);
  const [finalRefundAmount, setFinalRefundAmount] = useState("");
  const [bankName, setBankName] = useState("")
  const [name, setName] = useState("")
  const [branchName, setBranchName] = useState("")
  const [ifscCode, setIfscCode] = useState("")
  const [bankAcntNo, setBankAcntNo] = useState("")
  const [confirmBankAcntNo, setConfirmBankAcntNo] = useState("")
  const [aadharConfirmationModal, setAadharConfirmationModal] = useState("")
  const [aadharMobileVerificationModal, setAadharMobileVerificationModal] = useState("")
  const [panNumber, setPanNumber] = useState("");
  const [isPanValidated, setIsPanValidated] = useState(false)
  const [enableManualDoc, setEnableManualDoc] = useState(false)
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [refundError, setRefundError] = useState(false);
  const [closureTagConfirmationModal, setClosureTagConfirmationModal] = useState(false);
  const [closeTagType, setCloseTagType] = useState("1");
  const [aadharConfrimTag, setAadharConfrimTag] = useState("");
  const [otherText, setOtherText] = useState("");
  const [personName, setPersonName] = useState("");
  const [selectedProofType, setSelectedProofType] = useState("");
  const [accountType, setAccountType] = useState("");
  const [isTCApiSuccess, setIsTCApiSuccess] = useState(false);
  const [prevChequeImg, setPrevChequeImg] = useState("");
  const [prevIdFrontImg, setPrevIdFrontImg] = useState("");
  const [prevIdBackImg, setPrevIdBackImg] = useState("");
  const [journeyId, setJourneyId] = useState(false);
  const [panSubmit, setPanSubmit] = useState(false);
  const [userData, setUserData] = useState("");
  const [verificationData, setVerificationData] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [digilockerWaitingPeriod, setDigilockerWaitingPeriod] = useState(0);
  const [digilockerStatusRetryCount, setDigilockerStatusRetryCount] = useState(0);
  const [digilockerStatusCheckInterval, setDigilockerStatusCheckInterval] = useState(0);
  const [isInterval, setIsInterval] = useState(false);
  const [isdigiLockerSuccess, setIsdigiLockerSuccess] = useState(false)
  const [isInitiateVeriyApiSuccess, setInitiateVeriyApiSuccess] = useState(false)
  const [lastWithCCBtnEnable, setLastWithCCBtnEnable] = useState(false)
  const [lastWithCCBtnEnableForAllDocs, setLastWithCCBtnEnableForAllDocs] = useState(false)
  const [lastWithoutCCBtnEnableForAllDocs, setLastWithoutCCBtnEnableForAllDocs]= useState(false)
  const [lastWithoutCCBtnEnableForEkyc, setLastWithoutCCBtnEnableForEkyc]= useState(false)
  const [alertModal, setAlertModal] = useState({title: "", status: "", message: "", navigateScreen: "", actionButton: "",});
  const getProfileDetails = () => {
    setLoading(true);
    getUserDetails()
      .then((res) => {
        setLoading(false);
        setUserData(res);
      })
      .catch((err) => { setLoading(false);});
  };
  
  const getAllVehiclesListCloseTag = () => {
      setLoading(true);
      getAllVehiclesListForClosureTag()
        .then((res) => {
          if (res && !isEmpty(res)) {
            setVehicleLength(res?.length);
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log("<------------ error in tag details ----------->");
        });
  };

  useEffect(() => {
    getProfileDetails(); refundValueApi(); getDigilockerTimeDuration();getAllVehiclesListCloseTag()
    if(vehicleLength > 1 && userData?.kyc != "EKYC"){setEnableManualDoc(false) }
  }, []);

  useEffect(()=>{
    if(vehicleLength === 1 && userData?.kyc == "EKYC" && finalRefundAmount >= 1000){
      setLastWithCCBtnEnable(true)
      setLastWithCCBtnEnableForAllDocs(false)
      setLastWithoutCCBtnEnableForAllDocs(false)
      setLastWithoutCCBtnEnableForEkyc(false)
    }
  },[vehicleLength, userData?.kyc, finalRefundAmount])

  useEffect(()=>{
    if(vehicleLength === 1 && userData?.kyc != "EKYC"  && finalRefundAmount < 1000 ){
      setLastWithCCBtnEnable(false)
      setLastWithCCBtnEnableForAllDocs(false)
      setLastWithoutCCBtnEnableForEkyc(false)
      setLastWithoutCCBtnEnableForAllDocs(true)
    }
  },[vehicleLength, userData?.kyc, finalRefundAmount])
  
  useEffect(()=>{
    if(vehicleLength === 1 && userData?.kyc != "EKYC" && finalRefundAmount && finalRefundAmount >= 1000 && isdigiLockerSuccess == false  ){
      setLastWithCCBtnEnable(false)
      setLastWithoutCCBtnEnableForAllDocs(false)
      setLastWithoutCCBtnEnableForEkyc(false)
      setLastWithCCBtnEnableForAllDocs(true)
    }
  },[vehicleLength, userData?.kyc, finalRefundAmount,isdigiLockerSuccess])

  useEffect(()=>{
    if(vehicleLength === 1 && userData?.kyc == "EKYC"   ){
      setEnableManualDoc(false)
      setLastWithCCBtnEnable(false)
      setLastWithCCBtnEnableForAllDocs(false)
      setLastWithoutCCBtnEnableForAllDocs(false)
      setLastWithoutCCBtnEnableForEkyc(true)
    }
  },[vehicleLength,userData?.kyc])

  useEffect(() => {
    if (isInterval) {
      interval.current = setInterval(() => {
        if (count < digilockerStatusRetryCount) {
          digiLockerStatus()
          count++
          if (!isInterval) {
            console.log(count, "count+++")
            return clearInterval(interval.current)
          }
        } else if (count => digilockerStatusRetryCount) {
          clearInterval(interval.current)
          setShowLoader(false)
          setAlertModal({title: "Error", status: "error", message: "DigiLocker verification timeout", navigateScreen: "", actionButton: "OK",});
          setAlertModalVisible(true);
          setShowLoader(false)
          setEnableManualDoc(true)
        }
      }, [digilockerStatusCheckInterval])
    } else {
      clearInterval(interval.current)
      console.log("isterval false")
    }
  }, [isInterval])

  const onCloseModal = () => {
    setAlertModalVisible(false);
    if (isTCApiSuccess) { RootNavigation.navigate("servicerequest")}
    if(refundError){  RootNavigation.navigate("servicerequest/selectvehiclefortagclosure")}
  };
 
  const validatePan = (req) => {
    setPanNumber(req?.panNumber)
    setLoading(true)
    let params = {}
    params = { panNumber: req?.panNumber, fullName: req?.fullName, dob: req?.dob }
    panValidationV2(params).then(res => {
      setLoading(false)
      if (res.statusCode < 0 || res.statusCode == 500 || res.statusCode == 796) {
        setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
      }
      if (res.statusCode == 200) {
        setAadharConfirmationModal(true)
        setJourneyId(res?.data?.journeyId)
        setPanSubmit(true)
      }
    }).catch(err => { })
  }
  const initiate_verification = () => {
    setLoading(true)
    setPanSubmit(false)
    let param = { "mobileNo": userData?.mobileNo || "", }
    if (panNumber){ param = { ...param, journeyId: journeyId }}
    initiateVerification(param).then(res => {
      setLoading(false)
      if (res?.statusCode == 200) {
        setVerificationData(res?.data)
        setShowLoader(true)
        setAadharConfirmationModal(false)
        setInitiateVeriyApiSuccess(true)
        setTimeout(() => {
          digiLockerStatus(res?.data)
          count = 0
          setIsInterval(true)
        }, [digilockerWaitingPeriod])
      } else if (res?.statusCode < 0 || res?.statusCode == 500) {
        setAlertModal({title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK" });
        setAlertModalVisible(true);
      }
    }).catch(err => { })
  }

  const digiLockerStatus = (data = {}) => {
    let params = {stateCode: data?.stateCode || verificationData?.stateCode, journeyId: data?.journeyId || verificationData?.journeyId }
    getDigiLockerStatus(params).then((res) => {
      if (res?.statusCode < 0 || res?.statusCode == 500) {
        setAlertModal({  title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
        setShowLoader(false)
        setIsInterval(false)
        setAadharMobileVerificationModal(true)
        setEnableManualDoc(true)
        setIsdigiLockerSuccess(false)
      } else if (res?.statusCode == 200) {
        setAlertModal({ title: "Success", status: "success", message: res.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
        setShowLoader(false)
        setIsInterval(false)
        setIsdigiLockerSuccess(true)
        setLastWithCCBtnEnableForAllDocs(false)
        setLastWithoutCCBtnEnableForAllDocs(false)
      } else if (res?.statusCode == 1060) {
      }
    }).catch(err => console.log(err))
  }

  const getDigilockerTimeDuration = () => {
    setLoading(true)
    digilockerConfig().then((res) => {
      setLoading(false)
      if (res.data) {
        setDigilockerStatusCheckInterval(res.data.digilockerStatusCheckInterval * 1000)
        setDigilockerStatusRetryCount(res.data.digilockerStatusRetryCount)
        setDigilockerWaitingPeriod(res.data.digilockerWaitingPeriod * 1000)
      }
    }).catch(err => { })
  }

  const closureTagApi = async () => {
    let cancelChequeDocumentData = {
      docType: "CCH",
      docName: "Cancelled Cheque",
      docNo: "XXXXXX",
      uploadFile: prevChequeImg
    }
    let bankDetailsData = { bankName: bankName, bankAccountHolderName: name, bankBranchName: branchName,bankAccountNo: bankAcntNo,bankAccountType: accountType == "Savings Account" ? "SA" :"CA", bankIfscCode: ifscCode}
    let documentDetailsData = [
      {docType: "IDN", docName: selectedProofType ? selectedProofType : "", docNo: "XXXXXX",uploadFile: prevIdFrontImg},
      {docType: "IDN", docName: selectedProofType ? selectedProofType : "", docNo: "XXXXXX", uploadFile: prevIdBackImg},]
    let uploadDocuments = ""
    if(isdigiLockerSuccess && finalRefundAmount && finalRefundAmount >= 1000 ){
      uploadDocuments = [cancelChequeDocumentData]
    } else if(isdigiLockerSuccess && finalRefundAmount && finalRefundAmount < 1000){
      uploadDocuments = []
    }else if(!isdigiLockerSuccess && finalRefundAmount && finalRefundAmount >= 1000){
      uploadDocuments = [...documentDetailsData, cancelChequeDocumentData]
    } else if(isdigiLockerSuccess == false && finalRefundAmount < 1000){
      uploadDocuments = documentDetailsData
    }
    let closureTagReqObj = {
      closureType: "REGULAR",
      closureReason: closeTagType == "Others" ? otherText : closeTagType,
      vrn: selectedVehicle?.vrn ? selectedVehicle?.vrn : "",
      tagId: selectedVehicle?.fastagId ? selectedVehicle?.fastagId : "",
      chassis:  "",
      panJourneyId: journeyId ? journeyId : "",
      bankDetails: vehicleLength === 1 ? bankDetailsData : {},
      documents: (vehicleLength === 1  && userData?.kyc != "EKYC") ? uploadDocuments  : finalRefundAmount && finalRefundAmount >= 1000 ? [cancelChequeDocumentData]  : [],
    }
    setLoading(true)
    console.log(closureTagReqObj,'closureTagReqObj2')
    closureTag(closureTagReqObj).then(res => {
      setLoading(false)
      if (res?.statusCode == 200 || res?.statusCode == 1100) {
        setAlertModal({ title: "Successful",  status: "success",  message: res.message, navigateScreen: "", actionButton: "OK", });
        setAlertModalVisible(true);
        setClosureTagConfirmationModal(false)
        setIsTCApiSuccess(true)
      } else if (res?.statusCode < 0 || res?.statusCode == 500 || res?.statusCode == -1100) {
        setAlertModal({
          title: "Error",
          status: "error",
          message: res.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false)
        setClosureTagConfirmationModal(false)
      }}).catch(err => {
      setLoading(false)
      setClosureTagConfirmationModal(false)
    }) }

  const bankDetailsValidation = () => {
 
    if (bankName != ""&& branchName != "" && name !="" &&
    ifscCode != "" && ifscPattern.test(ifscCode) && bankAcntPattern.test(bankAcntNo) && bankAcntNo != "" &&
    confirmBankAcntNo != "" && (bankAcntNo == confirmBankAcntNo) && accountType != ""  ) {
      return true
    }}

  const refundValueApi = () => {
    let param = {
      "vrn": selectedVehicle?.vrn,
      tagNo: selectedVehicle?.fastagId
    }
    closureTagRefundCheck(param).then(res => {
      setLoading(false)
      if (res?.statusCode == 200) {
        setFinalRefundAmount(res?.data?.totalRefundAmount)
      } else if (res?.statusCode < 0 || res?.statusCode == 500) {
        setAlertModal({
          title: "Error",
          status: "error",
          message: res.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setRefundError(true)
      }}).catch(err => { })}

const withoutCCAllDocsValid = ()=>{
  if(prevIdFrontImg !="" && prevIdBackImg != "" && selectedProofType !=""
  && bankName != ""&& branchName != "" && name !="" &&
  ifscCode != "" && ifscPattern.test(ifscCode) && !bankAcntPattern.test(bankAcntPattern) && bankAcntNo != "" &&
  confirmBankAcntNo != "" && (bankAcntNo == confirmBankAcntNo) && accountType != "" ){
    return true
  }}

const withCCAllDocsValid = ()=>{
  if(prevChequeImg !="" && prevChequeImg !=null  && prevIdFrontImg !="" && prevIdBackImg != "" && selectedProofType !=""
  && bankName != ""&& branchName != "" && name !="" &&
  ifscCode != ""&& ifscPattern.test(ifscCode) && !bankAcntPattern.test(bankAcntPattern) && bankAcntNo != "" &&
  confirmBankAcntNo != "" && (bankAcntNo == confirmBankAcntNo) && accountType != "" ){
    return true
  }}

const otherTextValidation = () =>{
  if(closeTagType == "Others" ? otherText.length > 1 : closeTagType.length > 2){
      return true
  }}

const renderButtonWidget = () =>{
  return<>
  <ButtonWidget
    vehicleLength={vehicleLength} finalRefundAmount={finalRefundAmount}
    otherTextValidation={otherTextValidation} prevChequeImg={prevChequeImg}
    setClosureTagConfirmationModal={setClosureTagConfirmationModal}
    lastWithCCBtnEnable={lastWithCCBtnEnable} bankDetailsValidation={bankDetailsValidation}
    lastWithoutCCBtnEnableForAllDocs={lastWithoutCCBtnEnableForAllDocs} withoutCCAllDocsValid={withoutCCAllDocsValid}
    lastWithCCBtnEnableForAllDocs={lastWithCCBtnEnableForAllDocs} withCCAllDocsValid={withCCAllDocsValid}
    isdigiLockerSuccess={isdigiLockerSuccess} lastWithoutCCBtnEnableForEkyc={lastWithoutCCBtnEnableForEkyc}
  />
  </>
}
const renderdetailsItem=(key)=>{
  // alert(key)
  if(key == "details"){
    return <>
    <RenderDetails 
        setBankName={setBankName} bankName={bankName}
        setBranchName={setBranchName} branchName={branchName}
        setBankAcntNo={setBankAcntNo} bankAcntNo={bankAcntNo}
        setConfirmBankAcntNo={setConfirmBankAcntNo} confirmBankAcntNo={confirmBankAcntNo}
        setName={setName} name={name}
        setIfscCode={setIfscCode} ifscCode={ifscCode}
        setAccountType={setAccountType} accountType={accountType}
        bankDetails={true}
        />
    </>
  }else if(key == "cancelCheque"){
    return<>
    <RenderDetails finalRefundAmount={finalRefundAmount} cancelCheque={true} setPrevChequeImg = {setPrevChequeImg} prevChequeImg={prevChequeImg} /></>
  }else if(key == "documentDetails"){
    return<>
    <RenderDetails  documentDetails={true} setPersonName={setPersonName} personName={personName} setSelectedProofType={setSelectedProofType} selectedProofType={selectedProofType} setfrontImage = {setPrevIdFrontImg} setBackImage={setPrevIdBackImg} />
    </>
  }
}

  return (
    <>
      <View style={styles.container}>
        <View style={styles.closurePolicyWidget}>
          <Text style={styles.closurePolicyText}>{'FASTag Account(s) will be closed in 12 day(S) from the date of Approval of the closure request.'}</Text>
          <View style={styles.closurePolicyTextWidget}>
            <CButton title={"Closure Policy"} onPress={()=> console.log('')} style={styles.cancelBtn} ></CButton>
            <TouchableOpacity>
              <Text style={styles.closeText}>X</Text>
            </TouchableOpacity>
          </View>
        </View>
        <ScrollView vertical showsVerticalScrollIndicator={false} style={{ marginBottom:0, height: 780 }}>
          <View style={styles.navWidget}>
            <CView style={styles.contentSpace}>
              <CHeader title="Tag Closure" onPress={() => { 
                RootNavigation.navigate("servicerequest/selectvehiclefortagclosure")
                }} />
              <Text style={styles.backTextDesc}>{'Please select a Tag Account No. for closing tag account.'}</Text>
            </CView>
            {isInitiateVeriyApiSuccess || userData?.kyc == "EKYC" || aadharConfrimTag == "No" ?
              <CView style={styles.closureDocWidget}>
                <CText.fontBrown>{'Tag Closure Document'}</CText.fontBrown>
                <CView FR>
                  {userData?.kyc == "EKYC" ?
                    <CView>
                      <CButton XS title={"Digi-Locker Verified"} onPress={''} style={styles.digiBtn} ></CButton>
                      <CView style={styles.digilockIconPosition}> 
                        <CImage.DigilockerTickIcon ></CImage.DigilockerTickIcon> 
                      </CView>
                    </CView> :
                    <CView>
                      <CButton XS title={"Digi-Locker Verified"} isDisabled={(userData?.kyc == "Manual KYC" && isdigiLockerSuccess === false) || (userData?.kyc == "Min KYC" && isdigiLockerSuccess === false) ? true : false} style={styles.digiBtn} >  </CButton>
                      {aadharConfrimTag == "No" ? null : 
                       <CView style={styles.digilockIconPosition}>  
                         <CImage.DigilockerTickIcon ></CImage.DigilockerTickIcon>
                       </CView>}
                    </CView> }
                  <CView>
                    <CButton isDisabled={(userData?.kyc != "EKYC" && isdigiLockerSuccess === false)  ? false : true} XS title={"Documents Attached"} style={styles.docBtn} >  </CButton>
                    {(userData?.kyc == "Manual KYC" && isdigiLockerSuccess === false) || (userData?.kyc === "Min KYC" && isdigiLockerSuccess == false) || aadharConfrimTag == "No" ?
                      <CView style={styles.digilockIconPosition}>
                        <CImage.DigilockerTickIcon ></CImage.DigilockerTickIcon>
                      </CView>
                      : null}
                  </CView>
                </CView>
              </CView>
              : null}
          </View>
          <View style={styles.contentWidget}>
            <View style={styles.msgWidget}>
              <View style={styles.msgInnerCntTag}>
                <CText.backNavigationText>{"Selected Tags(1)"}</CText.backNavigationText>
                <View style={styles.selectedCard}>
                  <CImage.CarImg></CImage.CarImg> 
                  <CView style={styles.selectedCardText}>
                    <CView >
                      <CText.vrnText>{selectedVehicle?.vrn} </CText.vrnText>
                      <View>
                          {selectedVehicle.status && selectedVehicle.status != "Activated" && (
                            <View style={{flexDirection: "row", alignItems: "center",}} >
                              <Image
                                source={require("../../assets/images/hotlisted_icon.png")
                                }
                                style={{ height: 10, width: 10}}
                              />
                              <Text style={[ styles.lowBalanceText,{
                                    color:"#e9730d"
                                  },
                                ]}
                              >
                                {selectedVehicle.status == "Hotlisted by service provider"
                                  ? "Hotlisted"
                                  : selectedVehicle.status 
                                  }
                              </Text>
                            </View>
                          )}
                        </View>
                      <CText.vehicleModal>{selectedVehicle?.vehicleModel}  </CText.vehicleModal>
                    </CView>
                    <CView FR style={styles.tollWidget}>
                      <CImage.IconToll></CImage.IconToll>
                      <CView style={{ marginLeft: 20 }}>
                        <CText.priceText>{"\u20B9 "}{selectedVehicle?.fastagBalance.toFixed(2)}</CText.priceText>
                        <CText.vehicleModal>{"FASTag Balance"}</CText.vehicleModal>
                      </CView>
                    </CView>
                  </CView>
                  <CImage.TickActive></CImage.TickActive>
                </View>
              </View>
              <WarningWidget selectedVehicle={selectedVehicle} finalRefundAmount={finalRefundAmount} />
              <View style={styles.ButtonWidget}> {renderButtonWidget()}</View>
            </View>
            <>{selectedVehicle?.status == "Blacklisted" || selectedVehicle?.status == "Blacklist" || selectedVehicle?.status == "Hotlisted"|| finalRefundAmount < 0 ? 
              <CView></CView> :
              <DetailsWidget 
                setCloseTagType={setCloseTagType} closeTagType={closeTagType}
                setOtherText={setOtherText} otherText={otherText} finalRefundAmount={finalRefundAmount} setFinalRefundAmount={setFinalRefundAmount}
                vehicleLength={vehicleLength} aadharConfrimTag={aadharConfrimTag} isInitiateVeriyApiSuccess={isInitiateVeriyApiSuccess}
                userData={userData} panNumber={panNumber} setPanNumber={setPanNumber} setIsPanValidated={setIsPanValidated} isPanValidated={isPanValidated}
                validatePan={validatePan} enableManualDoc={enableManualDoc}
                renderButtonWidget={renderButtonWidget} RenderDetails={renderdetailsItem}
                panSubmit={panSubmit} setAadharConfirmationModal={setAadharConfirmationModal} 
            />
            }</>
           
          </View>
        </ScrollView>
        <View style={{marginBottom: 30 }}> 
        <QuickLinks navigation={props?.navigation} /> 
        </View>
      </View>
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert title={alertModal.title}  status={alertModal.status} message={alertModal.message}  navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} />
        </View> ) : null}
      <AdharModal 
        closureTagConfirmationModal={closureTagConfirmationModal} setClosureTagConfirmationModal={setClosureTagConfirmationModal}
        aadharConfirmationModal={aadharConfirmationModal} setAadharConfirmationModal = {setAadharConfirmationModal}
        aadharMobileVerificationModal={aadharMobileVerificationModal} setAadharMobileVerificationModal={setAadharMobileVerificationModal}
        aadharConfrimTag={aadharConfrimTag} setAadharConfrimTag={setAadharConfrimTag} initiate_verification={initiate_verification}  closureTagApi={closureTagApi}
      />
      {showLoader ? <View style={styles.containerLoader}>
        <View style={styles.indicatotWrapper}>
          <ActivityIndicator size={"large"} color="#707070" style={styles.spinner} />
          <Text style={styles.smsText}> {"SMS has been sent to mobile number"} </Text>
          <Text style={styles.digiVerifyText}> {"Please complete the digiLocker verification."} </Text>
        </View>
      </View> : null}
      {loading && <Loader />}
    </>
  );
}

